import React from "react";
import { withRouter } from "react-router-dom";
import CONSTANT from "./../../../constant";
import Loader from "./../../../component/common/Loader";
import AparEmployeeHeader, { normalizeManagers, mergeManagerData } from "./../../../component/common/AparEmployeeHeader";
import { getKpiReport, getReportingAssessment, saveReportingAssessment, updateReportingAssessment } from "./../../../actions/AppraisalCycleAction";

class aparReportingManagerForm1 extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      showLoader: false,
      isSubmitted: false,
      reportingAssessmentId: null,
      workPlanComments: { name: "workPlanComments", value: "", error: "", isRequired: true },
      workPlanAgree: { name: "workPlanAgree", value: "", error: "", isRequired: true },
      exceptionalContributionAgree: { name: "exceptionalContributionAgree", value: "", error: "", isRequired: true },
      exceptionalContributionComments: { name: "exceptionalContributionComments", value: "", error: "", isRequired: true },
      shortfallMet: { name: "shortfallMet", value: "", error: "", isRequired: true },
      shortfallDetails: { name: "shortfallDetails", value: "", error: "", isRequired: true },
      constraintsAgree: { name: "constraintsAgree", value: "", error: "", isRequired: true },
      constraintsComments: { name: "constraintsComments", value: "", error: "", isRequired: true },
      competencyUpgradationAgree: { name: "competencyUpgradationAgree", value: "", error: "", isRequired: true },
      competencyComments: { name: "competencyComments", value: "", error: "", isRequired: true }
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "APAR Reporting Manager Form - " + CONSTANT.organisation.name;
    const locationState = this.props.location?.state || {};
    const { kpiReportId: passedKpiReportId, employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo } = locationState;
    const employeeData = { employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo, ...normalizeManagers(locationState) };

    this.setState({ employeeData });

    // Use kpiReportId from location.state if available, otherwise fetch it
    if (passedKpiReportId) {
      this.setState({ kpiReportId: passedKpiReportId }, () => {
        this.loadExistingData(passedKpiReportId);
      });
    } else {
      this.fetchKpiReportId(employeeData);
    }
  }

  fetchKpiReportId = (employeeData: any) => {
    const { employeeCode, effectiveFrom } = employeeData;
    if (!employeeCode || !effectiveFrom) return;

    this.setState({ showLoader: true });
    getKpiReport({ employeeCode, effectiveFrom, reportType: "employee" }).then((res: any) => {
      const report = res?.result || res;
      const kpiReportId = report?.id || report?.kpiReportId || null;
      this.setState((prev: any) => ({ employeeData: { ...prev.employeeData, ...mergeManagerData(prev.employeeData, report || {}) } }));
      if (kpiReportId) {
        this.setState({ kpiReportId }, () => {
          this.loadExistingData(kpiReportId);
        });
      } else {
        this.setState({ showLoader: false });
      }
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  };

  loadExistingData = (kpiReportId: any) => {
    getReportingAssessment({ kpiReportId }).then((res: any) => {
      const data = res?.result || res;
      if (data) {
        this.setState((prev: any) => ({
          reportingAssessmentId: data.id,
          isSubmitted: !!data.is_submitted,
          workPlanComments: { ...this.state.workPlanComments, value: data.agree_accomplishments || "" },
          exceptionalContributionComments: { ...this.state.exceptionalContributionComments, value: data.exceptional_contribution_comment || "" },
          shortfallDetails: { ...this.state.shortfallDetails, value: data.significant_shortfall || "" },
          constraintsComments: { ...this.state.constraintsComments, value: data.agree_constraints || "" },
          competencyComments: { ...this.state.competencyComments, value: data.agree_competency_needs || "" },
          employeeData: { ...prev.employeeData, ...mergeManagerData(prev.employeeData, data) },
          showLoader: false,
        }));
      } else {
        this.setState({ showLoader: false });
      }
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  };

  render() {
    const { showLoader, isSubmitted } = this.state;

    return (
      <div className="container-fluid mb-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <div className="row mb-3">
                  <div className="col-md-8">
                    <h1 className="page-title">
                      <i className="fa fa-user text-primary mr-2" />
                      Appraisal of the Reporting Authority
                    </h1>
                  </div>
                  <div className="col-md-4 text-right">
                    <button className="btn btn-sm cancel-button" onClick={() => this.props.history.goBack()}>
                      <i className="fa fa-arrow-left mr-2" />Back
                    </button>
                  </div>
                </div>
                <AparEmployeeHeader {...this.state.employeeData} detailViewerRole="reporting" kpiReportId={this.state.kpiReportId} />

                {!showLoader && !this.state.kpiReportId && (
                  <div>
                    <div className="alert alert-warning d-flex align-items-center" role="alert">
                      <i className="fa fa-exclamation-triangle mr-2" style={{ fontSize: '1.5rem' }} />
                      <div>
                        <strong>KPI Report Not Available</strong>
                        <p className="mb-0 mt-1">
                          The KPI report for this employee has not been uploaded by HR yet.
                          Please contact HR to upload the KPI report before proceeding with the appraisal.
                        </p>
                      </div>
                    </div>
                    {/* <div className="d-flex justify-content-end gap-2 mt-3">
                      <button type="button" className="btn btn-outline-secondary" onClick={() => this.props.history.goBack()}>
                        <i className="fa fa-arrow-left mr-1" />Back
                      </button>
                    </div> */}
                  </div>
                )}

                {isSubmitted && (
                  <div className="alert alert-success mt-2">
                    <i className="fa fa-check-circle mr-1" /> This assessment has been submitted and is now view-only.
                  </div>
                )}

                {this.state.kpiReportId && <form onSubmit={this.onSubmit}>
                  {/* Question 1 */}
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <label className="form-label">
                        1. Please state whether you agree with the responses relating to the accomplishments of the work plan as filled out in Section II. If not, please furnish factual details.
                      </label>
                    </div>
                    <div className="col-md-12">
                      <textarea
                        name="workPlanComments"
                        value={this.state.workPlanComments.value}
                        onChange={this.onChange}
                        className={`form-control ${this.state.workPlanComments.error ? "is-invalid" : ""}`}
                        placeholder="Comments"
                        rows={2}
                        required
                        disabled={isSubmitted}
                      />
                      {this.state.workPlanComments.error && <div className="invalid-feedback">{this.state.workPlanComments.error}</div>}
                    </div>
                  </div>

                  {/* Question 2 */}
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <label className="form-label">
                        2. Please comment on the claim (if any) made by the officer reported upon about his exceptional contribution.
                      </label>
                    </div>
                    <div className="col-md-12">
                      <textarea
                        name="exceptionalContributionComments"
                        value={this.state.exceptionalContributionComments.value}
                        onChange={this.onChange}
                        className={`form-control ${this.state.exceptionalContributionComments.error ? "is-invalid" : ""}`}
                        placeholder="Comments"
                        rows={2}
                        required
                        disabled={isSubmitted}
                      />
                      {this.state.exceptionalContributionComments.error && <div className="invalid-feedback">{this.state.exceptionalContributionComments.error}</div>}
                    </div>
                  </div>

                  {/* Question 3 */}
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <label className="form-label">
                        3. Has the officer reported upon met with any significant shortfall in achieving the targets? If yes, please furnish factual details.
                      </label>
                    </div>
                    <div className="col-md-12">
                      <textarea
                        name="shortfallDetails"
                        value={this.state.shortfallDetails.value}
                        onChange={this.onChange}
                        className={`form-control ${this.state.shortfallDetails.error ? "is-invalid" : ""}`}
                        placeholder="Comments"
                        rows={2}
                        required
                        disabled={isSubmitted}
                      />
                      {this.state.shortfallDetails.error && <div className="invalid-feedback">{this.state.shortfallDetails.error}</div>}
                    </div>
                  </div>

                  {/* Question 4 */}
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <label className="form-label">
                        4. Do you agree with the constraints mentioned by the officer reported upon that had hindered his performance and, if so, to what extent?
                      </label>
                    </div>
                    <div className="col-md-12">
                      <textarea
                        name="constraintsComments"
                        value={this.state.constraintsComments.value}
                        onChange={this.onChange}
                        className={`form-control ${this.state.constraintsComments.error ? "is-invalid" : ""}`}
                        placeholder="Comments"
                        rows={2}
                        required
                        disabled={isSubmitted}
                      />
                      {this.state.constraintsComments.error && <div className="invalid-feedback">{this.state.constraintsComments.error}</div>}
                    </div>
                  </div>

                  {/* Question 5 */}
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <label className="form-label">
                        5. Do you agree with the competency up-gradation needs as identified by the officer?
                      </label>
                    </div>
                    <div className="col-md-12">
                      <textarea
                        name="competencyComments"
                        value={this.state.competencyComments.value}
                        onChange={this.onChange}
                        className={`form-control ${this.state.competencyComments.error ? "is-invalid" : ""}`}
                        placeholder="Comments"
                        rows={2}
                        required
                        disabled={isSubmitted}
                      />
                      {this.state.competencyComments.error && <div className="invalid-feedback">{this.state.competencyComments.error}</div>}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12 d-flex gap-2">
                      <button type="button" className="btn cancel-button" onClick={() => this.props.history.goBack()}>
                        {isSubmitted ? 'Back' : 'Cancel'}
                      </button>
                      {!isSubmitted && (
                        <button type="button" className="btn btn-secondary" onClick={this.handleSaveDraft} disabled={showLoader}>
                          {showLoader ? "Saving..." : "Save Draft"}
                        </button>
                      )}
                      {!isSubmitted && (
                        <button type="submit" className="btn submit-button" disabled={showLoader}>
                          {showLoader ? "Saving..." : "Save & Next"} <i className="fa fa-arrow-right ml-1" />
                        </button>
                      )}
                      {isSubmitted && (
                        <button type="button" className="btn btn-primary" onClick={() => {
                          const { employeeData, reportingAssessmentId, kpiReportId } = this.state;
                          this.props.history.push({
                            pathname: CONSTANT.component.aparReportingManagerForm2.url,
                            state: { ...employeeData, reportingAssessmentId, kpiReportId },
                          });
                        }}>
                          Next <i className="fa fa-arrow-right ml-1" />
                        </button>
                      )}
                    </div>
                  </div>
                </form>}
              </div>
            </div>
          </div>
        </div>
        {showLoader && <Loader />}
      </div>
    );
  }

  onChange = (e: any) => {
    const { name, value } = e.target;
    this.setState((prev: any) => ({
      [name]: { ...prev[name], value, error: "" }
    }));
  };

  validateForm = () => {
    const fields = ["workPlanComments", "exceptionalContributionComments", "shortfallDetails", "constraintsComments", "competencyComments"];
    let isValid = true;

    fields.forEach((field) => {
      if (!this.state[field].value.trim()) {
        this.setState((prev: any) => ({
          [field]: { ...prev[field], error: "This field is required" }
        }));
        isValid = false;
      }
    });

    return isValid;
  };

  buildFormData = () => ({
    agreeAccomplishments: this.state.workPlanComments.value,
    exceptionalContributionComment: this.state.exceptionalContributionComments.value,
    significantShortfall: this.state.shortfallDetails.value,
    agreeConstraints: this.state.constraintsComments.value,
    agreeCompetencyNeeds: this.state.competencyComments.value,
  });

  callSaveApi = (formData: any, callback: (newId: any) => void) => {
    const { reportingAssessmentId, kpiReportId } = this.state;
    if (!kpiReportId) {
      alert("KPI Report ID not found. Please go back and try again.");
      return;
    }
    this.setState({ showLoader: true });
    const apiCall = reportingAssessmentId
      ? updateReportingAssessment({ ...formData, reportingAssessmentId })
      : saveReportingAssessment({ ...formData, kpiReportId });
    apiCall.then((res: any) => {
      const newId = reportingAssessmentId || res?.result?.reportingAssessmentId || res?.reportingAssessmentId;
      if (newId && !this.state.reportingAssessmentId) {
        this.setState({ reportingAssessmentId: newId });
      }
      this.setState({ showLoader: false });
      callback(newId);
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  };

  handleSaveDraft = () => {
    const formData = this.buildFormData();
    this.callSaveApi(formData, () => {
      alert('Saved as draft.');
    });
  };

  onSubmit = (e: any) => {
    e.preventDefault();

    if (!this.validateForm()) return;

    const { employeeData } = this.state;
    const formData = this.buildFormData();

    this.callSaveApi(formData, (newId: any) => {
      this.props.history.push({
        pathname: CONSTANT.component.aparReportingManagerForm2.url,
        state: {
          ...employeeData,
          reportingAssessmentId: newId,
          form1Data: formData,
        },
      });
    });
  };
}

export default withRouter(aparReportingManagerForm1);
